/**
 * Theme Configuration
 * 
 * Centralized theme configuration for the application.
 * The active theme is determined by the REACT_APP_ENVIRONMENT variable.
 */

const themes = {
    default: {
        primaryColor: '#101E8E',      // CEMACO blue
        secondaryColor: '#6C757D',    // Secondary color
        primaryNavbarColor: '#101E8E', // Primary navbar color
        accentColor: '#93d500',       // CEMACO green accent
        logoType: null,                // Default CEMACO SVG logo
        logoTextColor: '#101E8E',      // Logo color for light backgrounds
        navbarTextColor: '#fff'        // Logo color for dark navbar
    },
    CONSTRUCEMACO: {
        primaryColor: '#FF6B00',       // CONSTRUCEMACO orange (placeholder - update as needed)
        secondaryColor: '#333333',     // Secondary color (placeholder)
        primaryNavbarColor: '#888888', // Primary navbar color (placeholder)
        accentColor: '#FFD700',        // Accent color (placeholder)
        logoType: 'CONSTRUCEMACO',     // CONSTRUCEMACO WebP logo
        logoTextColor: '#FF6B00',      // Logo color for light backgrounds (placeholder)
        navbarTextColor: '#000'        // Logo color for dark navbar
    }
};

/**
 * Get the current theme based on environment variable
 * @returns {Object} Theme configuration object
 */
const getTheme = () => {
    const env = process.env.REACT_APP_ENVIRONMENT;
    return themes[env] || themes.default;
};

export default getTheme;
